import {
  clearLoginNoticeDismissal,
  clearLoginNotice,
  clearLoginNoticeForDifferentUser,
  dismissLoginNotice,
  getUserId,
  isLoginNoticeDismissedForUser,
  setLoginNoticeForUser
} from '~/utils/accountSharingLoginNotice'

export const state = () => ({
  trackingStatus: 'ineligible',
  riskLevel: null
})
export const getters = {}
export const mutations = {
  setTrackingContext(moduleState, { trackingStatus, riskLevel = null }) {
    moduleState.trackingStatus = trackingStatus
    moduleState.riskLevel = riskLevel
  }
}

let refreshGeneration = 0

export function parseAccountStatus(response) {
  const riskLevel =
    response && typeof response.riskLevel === 'string'
      ? response.riskLevel.toLowerCase()
      : null
  const eligible =
    response &&
    response.showLoginNotice === true &&
    (riskLevel === 'high' || riskLevel === 'medium')

  return {
    eligible: Boolean(eligible),
    riskLevel: eligible ? riskLevel : null
  }
}

function setTrackingContext(commit, trackingStatus, riskLevel = null) {
  if (typeof commit === 'function') {
    commit('setTrackingContext', { trackingStatus, riskLevel })
  }
}

function isCurrentRequest(context, generation, userId) {
  return (
    generation === refreshGeneration &&
    context.$auth &&
    context.$auth.loggedIn &&
    String(getUserId(context.$auth.user) || '') === userId
  )
}

function refreshUsetifulTags(context, shouldRefresh) {
  if (
    shouldRefresh &&
    context.$usetiful &&
    typeof context.$usetiful.refreshTags === 'function'
  ) {
    context.$usetiful.refreshTags()
  }
}

export const actions = {
  async refresh({ commit } = {}) {
    const generation = ++refreshGeneration
    let storageChanged = false
    setTrackingContext(commit, 'pending')

    if (!process.client || !this.$auth || !this.$auth.loggedIn) {
      storageChanged = clearLoginNotice()
      setTrackingContext(commit, 'ineligible')
      refreshUsetifulTags(this, storageChanged)
      return storageChanged
    }

    const userId = String(getUserId(this.$auth && this.$auth.user) || '')
    if (!userId) {
      storageChanged = clearLoginNotice()
      setTrackingContext(commit, 'ineligible')
      refreshUsetifulTags(this, storageChanged)
      return storageChanged
    }

    storageChanged = clearLoginNoticeForDifferentUser(userId)

    if (isLoginNoticeDismissedForUser(userId)) {
      storageChanged = clearLoginNotice() || storageChanged
      setTrackingContext(commit, 'ineligible')
      refreshUsetifulTags(this, storageChanged)
      return storageChanged
    }

    try {
      const response = await this.$axios.$get(
        `${process.env.IMPORTSCAN_AWS_URL}/zoho/account-status`,
        { params: { _: Date.now() } }
      )

      if (!isCurrentRequest(this, generation, userId)) {
        return storageChanged
      }

      const accountStatus = parseAccountStatus(response)
      if (accountStatus.eligible) {
        setTrackingContext(commit, 'eligible', accountStatus.riskLevel)
        if (!isLoginNoticeDismissedForUser(userId)) {
          storageChanged = setLoginNoticeForUser(userId) || storageChanged
        }
      } else {
        setTrackingContext(commit, 'ineligible')
        storageChanged = clearLoginNotice() || storageChanged
      }
    } catch (error) {
      if (!isCurrentRequest(this, generation, userId)) {
        return storageChanged
      }

      setTrackingContext(commit, 'ineligible')
      storageChanged = clearLoginNotice() || storageChanged
    }

    refreshUsetifulTags(this, storageChanged)
    return storageChanged
  },

  dismiss() {
    const storageChanged = dismissLoginNotice(
      getUserId(this.$auth && this.$auth.user)
    )
    refreshUsetifulTags(this, storageChanged)

    return storageChanged
  },

  clearLoginNoticeStorage({ commit } = {}) {
    refreshGeneration += 1
    const storageChanged = clearLoginNotice()
    clearLoginNoticeDismissal()
    setTrackingContext(commit, 'ineligible')
    refreshUsetifulTags(this, storageChanged)

    return storageChanged
  }
}
